var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFileAddDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_3979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5C15 14.91 14.66 15.25 14.25 15.25H12.75V16.75C12.75 17.16 12.41 17.5 12 17.5C11.59 17.5 11.25 17.16 11.25 16.75V15.25H9.75C9.34 15.25 9 14.91 9 14.5C9 14.09 9.34 13.75 9.75 13.75H11.25V12.25C11.25 11.84 11.59 11.5 12 11.5C12.41 11.5 12.75 11.84 12.75 12.25V13.75H14.25C14.66 13.75 15 14.09 15 14.5ZM21 9.25V16.75C21 18.82 19.32 20.5 17.25 20.5H6.75C4.68 20.5 3 18.82 3 16.75V7.75C3 5.68 4.68 4 6.75 4H8.65C9 4 9.34 4.08 9.66 4.24L12.03 5.43C12.13 5.48 12.25 5.51 12.37 5.51H17.27C19.34 5.51 21.02 7.19 21.02 9.26L21 9.25ZM4.5 7.75V8.5H19.36C19.04 7.6 18.2 7 17.25 7H12.35C12 7 11.66 6.92 11.34 6.76L8.97 5.58C8.87 5.53 8.75 5.5 8.63 5.5H6.73C5.49 5.5 4.48 6.51 4.48 7.75H4.5ZM19.5 16.75V10H4.5V16.75C4.5 17.99 5.51 19 6.75 19H17.25C18.49 19 19.5 17.99 19.5 16.75Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_3979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16.5,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileAddDark);
export default __webpack_public_path__ + "static/media/ico-file-add-dark.4fb5aaf27c772807ded4c53f1e490a32.svg";
export { ForwardRef as ReactComponent };